import { SEQUENCER_INTERFACE_PREFIX } from '../../actionTypePrefixes';
import { addActionTypePrefix } from '../../util/addActionTypePrefix';
import { SEQUENCER_INTERFACE_TYPE } from '../interfaceTypes';

export const SET_SUGGESTED_VALUES = addActionTypePrefix(
   'SET_SUGGESTED_VALUES',
   SEQUENCER_INTERFACE_TYPE
);
export const setSuggestedValues = (suggestedValues) => ({
   type: SET_SUGGESTED_VALUES,
   suggestedValues,
});

export const SET_HAS_REFERENCE = addActionTypePrefix(
   'SET_HAS_REFERENCE',
   SEQUENCER_INTERFACE_TYPE
);
export const setHasReference = (hasReference) => ({
   type: SET_HAS_REFERENCE,
   hasReference,
});

export const TOGGLE_REFERENCE_PLAYING = addActionTypePrefix(
   'TOGGLE_REFERENCE_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const toggleReferencePlaying = () => ({
   type: TOGGLE_REFERENCE_PLAYING,
});

export const TOGGLE_USER_PLAYING = addActionTypePrefix(
   'TOGGLE_USER_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const toggleUserPlaying = () => ({
   type: TOGGLE_USER_PLAYING,
});

export const SET_REFERENCE_PLAYING = addActionTypePrefix(
   'SET_REFERENCE_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const setReferencePlaying = (isPlaying) => ({
   type: SET_REFERENCE_PLAYING,
   isPlaying,
});

export const SET_USER_PLAYING = addActionTypePrefix(
   'SET_USER_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const setUserPlaying = (isPlaying) => ({
   type: SET_USER_PLAYING,
   isPlaying,
});

export const SET_LOOP_MODE = addActionTypePrefix(
   'SET_LOOP_MODE',
   SEQUENCER_INTERFACE_TYPE
);
export const setLoopMode = () => ({
   type: SET_LOOP_MODE,
});

export const TOGGLE_LOOP_MODE_PLAYING = addActionTypePrefix(
   'TOGGLE_LOOP_MODE_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const toggleLoopModePlaying = () => ({
   type: TOGGLE_LOOP_MODE_PLAYING,
});

export const SET_LOOP_MODE_PLAYING = addActionTypePrefix(
   'SET_LOOP_MODE_PLAYING',
   SEQUENCER_INTERFACE_TYPE
);
export const setLoopModePlaying = (isPlaying) => ({
   type: SET_LOOP_MODE_PLAYING,
   isPlaying,
});

export const TOGGLE_LOOP_MODE_REFERENCE = addActionTypePrefix(
   'TOGGLE_LOOP_MODE_REFERENCE',
   SEQUENCER_INTERFACE_TYPE
);
export const toggleLoopModeReference = () => ({
   type: TOGGLE_LOOP_MODE_REFERENCE,
});

export const SET_LOOP_MODE_REFERENCE = addActionTypePrefix(
   'SET_LOOP_MODE_REFERENCE',
   SEQUENCER_INTERFACE_TYPE
);
export const setLoopModeReference = (isReference) => ({
   type: SET_LOOP_MODE_REFERENCE,
   isReference,
});

export const STOP_PLAYING = addActionTypePrefix(
   'STOP_PLAYING',
   SEQUENCER_INTERFACE_PREFIX
);
export const stopPlaying = (allowSustain) => ({
   type: STOP_PLAYING,
   allowSustain,
});

/* Settings */

// Set the tempo in BPM
export const SET_TEMPO = 'SET_TEMPO';
export const setTempo = (tempo) => ({
   type: SET_TEMPO,
   tempo,
});

// Set the reference tempo in BPM
export const SET_REFERENCE_TEMPO = 'SET_REFERENCE_TEMPO';
export const setReferenceTempo = (tempo) => ({
   type: SET_REFERENCE_TEMPO,
   tempo,
});

// Set the tempos in BPM
export const SET_TEMPOS = 'SET_TEMPOS';
export const setTempos = ({ tempo, referenceTempo, tempoConfig }) => ({
   type: SET_TEMPOS,
   tempo,
   referenceTempo,
   tempoConfig,
});

export const SET_SWING = 'SET_SWING';
export const setSwing = (swing) => ({
   type: SET_SWING,
   swing,
});

export const SET_REFERENCE_SWING = 'SET_REFERENCE_SWING';
export const setReferenceSwing = (swing) => ({
   type: SET_REFERENCE_SWING,
   swing,
});

export const SET_SWINGS = 'SET_SWINGS';
export const setSwings = ({ swing, referenceSwing, swingConfig }) => ({
   type: SET_SWINGS,
   swing,
   referenceSwing,
   swingConfig,
});

// Set the number of beats in the sequencer (loop)
export const SET_BEAT_COUNT = 'SET_BEAT_COUNT';
export const setBeatCount = (beatCount) => ({
   type: SET_BEAT_COUNT,
   beatCount,
});

/* Advanced Settings */

// Set how many seconds the sequencer looks forward to schedule notes
export const SET_LOOKAHEAD = 'SET_LOOKAHEAD';
export const setLookahead = (lookahead) => ({
   type: SET_LOOKAHEAD,
   lookahead,
});

// Set how often to run the note scheduling function in milliseconds
export const SET_INTERVAL_TIME = 'SET_INTERVAL_TIME';
export const setIntervalTime = (intervalTime) => ({
   type: SET_INTERVAL_TIME,
   intervalTime,
});

// Set how many subdivisions each beat has where a note can be placed
// Divide beats into 24 intervals to allow 8 and 12 subdivisions of each beat
// for basic step sequencer only use 4 per beat (every 6th interval)
export const SET_PARTS_PER_BEAT = 'SET_PARTS_PER_BEAT';
export const setPartsPerBeat = (partsPerBeat) => ({
   type: SET_PARTS_PER_BEAT,
   partsPerBeat,
});

/* View */
export const SET_VIEW = 'SET_VIEW';
export const setView = (viewData) => ({
   type: SET_VIEW,
   viewData,
});

/* Instruments */

// Sets the array of instruments
export const SET_INSTRUMENTS = 'SET_INSTRUMENTS';
export const setInstruments = (instruments) => ({
   type: SET_INSTRUMENTS,
   instruments,
});

// Adds instruments to the array of instruments
export const ADD_INSTRUMENTS = 'ADD_INSTRUMENTS';
export const addInstruments = (instruments) => ({
   type: ADD_INSTRUMENTS,
   instruments,
});

// Toggles the selected part (note, beat partition) in the selected instrument's pattern
export const TOGGLE_PART = 'TOGGLE_PART';
export const togglePart = (instrumentIndex, partIndex) => ({
   type: TOGGLE_PART,
   instrumentIndex,
   partIndex,
});

export const ADD_NOTE_TO_PART = 'ADD_NOTE_TO_PART';
export const addNoteToPart = (instrumentIndex, partIndex, note) => ({
   type: ADD_NOTE_TO_PART,
   instrumentIndex,
   partIndex,
   note,
});

export const REMOVE_NOTE_FROM_PART = 'REMOVE_NOTE_FROM_PART';
export const removeNoteFromPart = (instrumentIndex, partIndex, note) => ({
   type: REMOVE_NOTE_FROM_PART,
   instrumentIndex,
   partIndex,
   note,
});

/* Piano Roll Controls */

export const PIANO_ROLL_NOTE_MOUSEDOWN = 'PIANO_ROLL_NOTE_MOUSEDOWN';
export const pianoRollNoteMousedown = (
   startPart,
   note,
   mouseButton,
   clientX,
   clientY
) => ({
   type: PIANO_ROLL_NOTE_MOUSEDOWN,
   startPart,
   note,
   mouseButton,
   clientX,
   clientY,
});

export const PIANO_ROLL_NOTE_RESIZE_HANDLE_MOUSEDOWN =
   'PIANO_ROLL_NOTE_RESIZE_HANDLE_MOUSEDOWN';
export const pianoRollNoteResizeHandleMousedown = (
   startPart,
   note,
   noteLength,
   mouseButton,
   clientX,
   clientY
) => ({
   type: PIANO_ROLL_NOTE_RESIZE_HANDLE_MOUSEDOWN,
   startPart,
   note,
   noteLength,
   mouseButton,
   clientX,
   clientY,
});

export const PIANO_ROLL_NOTE_MOUSEENTER = 'PIANO_ROLL_NOTE_MOUSEENTER';
export const pianoRollNoteMouseenter = (startPart, note) => ({
   type: PIANO_ROLL_NOTE_MOUSEENTER,
   startPart,
   note,
});

export const PIANO_ROLL_MOUSEMOVE = 'PIANO_ROLL_MOUSEMOVE';
export const pianoRollMousemove = (clientX, clientY) => ({
   type: PIANO_ROLL_MOUSEMOVE,
   clientX,
   clientY,
});

export const PIANO_ROLL_MOUSEDOWN = 'PIANO_ROLL_MOUSEDOWN';
export const pianoRollMousedown = (
   mouseButton,
   elementX,
   elementY,
   clientX,
   clientY
) => ({
   type: PIANO_ROLL_MOUSEDOWN,
   mouseButton,
   elementX,
   elementY,
   clientX,
   clientY,
});

export const PIANO_ROLL_MOUSEUP = 'PIANO_ROLL_MOUSEUP';
export const pianoRollMouseup = (mouseButton) => ({
   type: PIANO_ROLL_MOUSEUP,
   mouseButton,
});

export const POP_NOTE_INTO_PENDING = 'POP_NOTE_INTO_PENDING';
export const popNoteIntoPending = (instrumentIndex, partIndex, note) => ({
   type: POP_NOTE_INTO_PENDING,
   instrumentIndex,
   partIndex,
   note,
});

export const SET_PENDING_NOTE = 'SET_PENDING_NOTE';
export const setPendingNote = (pendingNote) => ({
   type: SET_PENDING_NOTE,
   pendingNote,
});

export const PLACE_PENDING_NOTE = 'PLACE_PENDING_NOTE';
export const placePendingNote = () => ({
   type: PLACE_PENDING_NOTE,
});

export const PATCH_PENDING_NOTE = 'PATCH_PENDING_NOTE';
export const patchPendingNote = (note) => ({
   type: PATCH_PENDING_NOTE,
   note,
});

export const CLICK_NOTE_DELETE_ICON = 'CLICK_NOTE_DELETE_ICON';
export const clickNoteDeleteIcon = (note, startPart) => ({
   type: CLICK_NOTE_DELETE_ICON,
   note,
   startPart,
});

export const SET_PATTERN = 'SET_PATTERN';
export const setPattern = (pattern, isReference) => ({
   type: SET_PATTERN,
   pattern,
   isReference,
});

export const SET_TRACK_PATTERN = 'SET_TRACK_PATTERN';
export const setTrackPattern = (trackIndex, pattern, isReference) => ({
   type: SET_TRACK_PATTERN,
   trackIndex,
   pattern,
   isReference,
});

/* mixer */
export const SET_MIXER_TRACK_PAN = 'SET_MIXER_TRACK_PAN';
export const setMixerTrackPan = (instrumentIndex, pan) => ({
   type: SET_MIXER_TRACK_PAN,
   instrumentIndex,
   pan,
});

export const SET_MIXER_TRACK_GAIN = 'SET_MIXER_TRACK_GAIN';
export const setMixerTrackGain = (instrumentIndex, gain) => ({
   type: SET_MIXER_TRACK_GAIN,
   instrumentIndex,
   gain,
});

export const ADD_MIXER_TRACK_EFFECT = 'ADD_MIXER_TRACK_EFFECT';
export const addMixerTrackEffect = (instrumentIndex, effect) => ({
   type: ADD_MIXER_TRACK_EFFECT,
   effect,
   instrumentIndex,
});

export const UPDATE_MIXER_TRACK_EFFECT = 'UPDATE_MIXER_TRACK_EFFECT';
export const updateMixerTrackEffect = (
   instrumentIndex,
   effectIndex,
   update,
   reference
) => ({
   type: UPDATE_MIXER_TRACK_EFFECT,
   instrumentIndex,
   effectIndex,
   update,
   reference,
});

export const MOVE_MIXER_TRACK_EFFECT = 'MOVE_MIXER_TRACK_EFFECT';
export const moveMixerTrackEffect = (activeIndex, overIndex) => ({
   type: MOVE_MIXER_TRACK_EFFECT,
   activeIndex,
   overIndex,
});

export const TOGGLE_MIXER_TRACK_MUTE = 'TOGGLE_MIXER_TRACK_MUTE';
export const toggleMixerTrackMute = (trackIndex) => ({
   type: TOGGLE_MIXER_TRACK_MUTE,
   trackIndex,
});

export const SET_MIXER_TRACK_MUTE = 'SET_MIXER_TRACK_MUTE';
export const setMixerTrackMute = (trackIndex, mute) => ({
   type: SET_MIXER_TRACK_MUTE,
   trackIndex,
   mute,
});

export const TOGGLE_MIXER_TRACK_SOLO = 'TOGGLE_MIXER_TRACK_SOLO';
export const toggleMixerTrackSolo = (trackIndex) => ({
   type: TOGGLE_MIXER_TRACK_SOLO,
   trackIndex,
});

export const SET_MIXER_TRACK_SOLO = 'SET_MIXER_TRACK_SOLO';
export const setMixerTrackSolo = (trackIndex, solo) => ({
   type: SET_MIXER_TRACK_SOLO,
   trackIndex,
   solo,
});

// Loops

export const INSERT_INTO_LOOP_QUEUE = addActionTypePrefix(
   'INSERT_INTO_LOOP_QUEUE',
   SEQUENCER_INTERFACE_PREFIX
); // need to provide array of loop kit ids, category ids, and loop ids
export const insertIntoLoopQueue = (insertArray, useNextLevelQueue) => ({
   type: INSERT_INTO_LOOP_QUEUE,
   insertArray,
   useNextLevelQueue,
});

export const LOAD_LOOP = addActionTypePrefix(
   'LOAD_LOOP',
   SEQUENCER_INTERFACE_PREFIX
);
export const loadLoop = ({ loopKitId, categoryId, loopId }) => ({
   type: LOAD_LOOP,
   loopKitId,
   categoryId,
   loopId,
});

export const ADD_LOOP = addActionTypePrefix(
   'ADD_LOOP',
   SEQUENCER_INTERFACE_PREFIX
);
export const addLoop = (cacheId, loop) => ({
   type: ADD_LOOP,
   cacheId,
   loop,
});

export const SET_CURRENT_LOOP_FROM_QUEUE = addActionTypePrefix(
   'SET_CURRENT_LOOP_FROM_QUEUE',
   SEQUENCER_INTERFACE_PREFIX
);
export const setCurrentLoopFromQueue = (useNextLevelQueue) => ({
   type: SET_CURRENT_LOOP_FROM_QUEUE,
   useNextLevelQueue,
});

export const SET_CURRENT_LOOP = addActionTypePrefix(
   'SET_CURRENT_LOOP',
   SEQUENCER_INTERFACE_PREFIX
);
export const setCurrentLoop = (loop) => ({
   type: SET_CURRENT_LOOP,
   loop,
});

export const REPLACE_QUEUE_WITH_NEXT_LEVEL = addActionTypePrefix(
   'REPLACE_QUEUE_WITH_NEXT_LEVEL',
   SEQUENCER_INTERFACE_PREFIX
);
export const replaceQueueWithNextLevel = () => ({
   type: REPLACE_QUEUE_WITH_NEXT_LEVEL,
});

export const SET_NEXT_LEVEL_QUEUE = addActionTypePrefix(
   'SET_NEXT_LEVEL_QUEUE',
   SEQUENCER_INTERFACE_PREFIX
);
export const setNextLevelQueue = (queue) => ({
   type: SET_NEXT_LEVEL_QUEUE,
   queue,
});

export const LOAD_LOOP_CATEGORY_COUNT = addActionTypePrefix(
   'LOAD_LOOP_CATEGORY_COUNT',
   SEQUENCER_INTERFACE_PREFIX
);
export const loadLoopCategoryCount = ({ loopKitId, categoryId }) => ({
   type: LOAD_LOOP_CATEGORY_COUNT,
   loopKitId,
   categoryId,
});

export const ADD_LOOP_CATEGORY_COUNT = addActionTypePrefix(
   'ADD_LOOP_CATEGORY_COUNT',
   SEQUENCER_INTERFACE_PREFIX
);
export const addLoopCategoryCount = ({ loopKitId, categoryId, count }) => ({
   type: ADD_LOOP_CATEGORY_COUNT,
   loopKitId,
   categoryId,
   count,
});

export const SET_TRACK_OUT_ROUTING = 'SET_TRACK_OUT_ROUTING';
export const setTrackOutRouting = (trackIndex, isRouted) => ({
   type: SET_TRACK_OUT_ROUTING,
   trackIndex,
   isRouted,
});

export const SET_TRACK_ROUTING_ITEM = 'SET_TRACK_ROUTING_ITEM';
export const setTrackRoutingItem = (
   fromTrackIndex,
   toTrackIndex,
   isRouted
) => ({
   type: SET_TRACK_ROUTING_ITEM,
   fromTrackIndex,
   toTrackIndex,
   isRouted,
});

export const SET_SEND_GAIN = 'SET_SEND_GAIN';
export const setSendGain = (fromTrackIndex, toTrackIndex, gain) => ({
   type: SET_SEND_GAIN,
   fromTrackIndex,
   toTrackIndex,
   gain,
});
